import React, { FC } from "react";
import cx from "classnames";
import { parseBannerContent, ENV } from "../../utils";
import { getEnvKey } from "../../environment";

// Parse banner content from environment variable
const bannerContent = parseBannerContent(getEnvKey(ENV.REACT_APP_BANNER));

export const BANNER_TITLE = bannerContent?.title || '';
export const BANNER_SUBTITLE = bannerContent?.subtitle || '';

type BannerProps = {
  onClose: () => void;
};

export const Banner: FC<BannerProps> = ({ onClose }) => {
  return (
    <div className="w-full bg-orange py-2 px-4 relative hidden md:block">
      <div className="container mx-auto flex items-center justify-center">
        <div className="w-3/4 text-center text-white">
          <div className="font-bold text-base mb-0.5">
            <span dangerouslySetInnerHTML={{ __html: BANNER_TITLE }} />
          </div>
          <div className="italic text-sm">
            {BANNER_SUBTITLE}
          </div>
        </div>
        <button
          onClick={onClose}
          className={cx(
            "absolute right-4 top-1/2 transform -translate-y-1/2",
            "w-6 h-6 rounded-full bg-white bg-opacity-20 hover:bg-opacity-30",
            "flex items-center justify-center text-white text-lg font-bold",
            "cursor-pointer transition-colors duration-200"
          )}
          aria-label="Close banner"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default Banner;
